<template>
  <div
    v-analytics.pageview="'distributes'"
    class="page page-language"
  >
    <div class="language">
      <div class="language-title">
        {{ tips }}
      </div>
      <div class="language-action qv-options">
        <b-button
          v-for="(item, index) in surveys"
          :key="index"
          type="is-primary"
          class="language-btn"
          :class="'qv-options-' + ( fromDesktop|| fromLandscape ?perLineNum : 1)"
          @click="handleChoose(item)"
        >
          {{ item.button }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getDistributes } from '@/apis/survey';
import { shuffle } from '@/utils/questions/questionRandom';
import { mapState } from 'vuex';

export default {
  name: 'Distributes',

  data() {
    return {
      id: '',
      tips: '',
      surveys: [],
      perLineNum: 1,
    };
  },

  computed: {
    ...mapState(['fromDesktop', 'fromLandscape']),
  },

  created() {
    const { distributeId } = this.$route.query;
    this.id = distributeId;
    this.loadSurveys();
  },

  methods: {
    async loadSurveys() {
      try {
        const res = await getDistributes(this.id);
        const { data } = res;
        const { relationships } = data;
        this.tips = data?.tips;
        this.surveys = data?.surveys.map((item) => {
          let survey = relationships[item.surveyId];
          survey = Array.isArray(survey) ? survey[0] : survey;
          const { language } = survey.configs;
          return {
            button: item.button,
            surveyId: item.surveyId,
            language,
          };
        });
        this.perLineNum = data?.perLineNum === 0 ? 1 : data.perLineNum;
        if (data.random) {
          this.surveys = shuffle(this.surveys);
        }
      } catch (err) {
        const { query } = this.$route;
        query.type = 'invalid';
        delete query.distributeId;
        this.$router.replace({ name: 'other', query });
      }
    },
    handleChoose(item) {
      const { query } = this.$route;
      this.$router.push({
        name: 'home',
        query: { ...query, sid: item.surveyId },
      });
    },
  },
};
</script>

<style lang="scss">
  $checkboxSize: 30px / $px;
  $desktopCheckboxSize: 14px;

  .page-language{
    min-height: 100vh;
    background: $white;
  }

  .language {
    padding: $padding * 3 $padding;
    background: $white;
    &-title{
      text-align: center;
      font-size: 18px;
    }
    &-action{
      max-width: 850px;
      margin: 0 auto;
    }
    &-btn {
      min-width: 100%;
      margin:5px;
      margin-top: $normalGap;
    }
  }

  .language-action{
    max-width: 850px;
  }

  .qv-options {
    display: flex;
    flex-flow: row wrap;

    .language {
      &-btn {
        flex-wrap:wrap;
        min-width: unset;
        height:fit-content;
        min-height:40px;
        margin-left: 0;

        span {
          display: inline-block;
          white-space: pre-wrap;
          line-height: 20px;
        }
      }
    }

    .qv-options-1 {
        width: 100%;
        margin-right: 0;
      }

      .qv-options-2 {
        width: 47%;
        margin-right: 5.5%;
      }

      .qv-options-2:nth-of-type(2n){
        margin-right: 0;
      }

      .qv-options-3 {
        width: 32.3333%;
        margin-right: 1.5%;
      }

      .qv-options-3:nth-of-type(3n){
        margin-right: 0;
      }
  }
</style>
